/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import decorate from '../common/utils/decorate';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Checkbox from '../ui/Checkbox';
import Grid from '../ui/Grid';
import Skeleton from '../ui/Skeleton';
import Text from '../ui/Text';
import Logo from '../ui/Logo';

import Query from './Query';

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {};

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);

      this.state = {
        address: props.address
      };
    }

    findAddress = (list, address) => {
      if (!list) return -1;

      return list.findIndex(
        (item) =>
          item.value.service === address?.service &&
          item.value.method === address?.method &&
          item.value.company === address?.company &&
          item.value.tariff === address?.tariff &&
          item.value.point?.id === address?.point?.id &&
          item.value.address?.locality === address?.address?.locality
      );
    };

    renderAddress = (locality, address) => {
      const result = [];
      
      if (locality) {
        locality = locality.split(', ');
        
        if (locality?.length)
          result.push(locality[locality.length - 1]);
      }
      
      if (address)
        result.push(address);
      
      return result.join(', ');
    };

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { onNextPage, onPrevPage } = this.props;

      const {
        visitor,
        warehouse,
        cart,

        langString,

        deliveryInfo,

        serviceList,
        methodList,
        companyList,
        tariffList
      } = this.context;

      const showAddressList =
        methodList && companyList && tariffList ? [] : null;

      if (showAddressList) {
        if (!deliveryInfo?.address?.length)
          setTimeout(() => onNextPage(false, address), 1);
        
        let warehouseAddress = null;

        if (warehouse.id && warehouse.is_internal_pickup) {
          const service = serviceList.find((service) => service.code === 'internal');
          const method = methodList.find((method) => method.code === 'pickup');
          const company = service && companyList.find((company) => company.service.id === service.id && company.code === 'internal');
          const tariff = service && tariffList.find((tariff) => tariff.service.id === service.id);

          const warehouseLocality = warehouse.locality?.value
            ? warehouse.locality.value.join(', ')
            : warehouse.locality;

          if (service && method && company && tariff && warehouseLocality) {
            const contactAddress = deliveryInfo?.address?.find((item) => item.recipient?.lastname && item.recipient?.firstname);

            warehouseAddress = {
              service: service.code,
              method: method.id,
              company: company.id,
              tariff: tariff.id,
              point: {
                id: warehouse.id,
                title: warehouse.title,
                description: warehouse.description,
                address: this.renderAddress(warehouseLocality, warehouse.address)
              },

              address: { locality: warehouseLocality },
              recipient: contactAddress
                ? { ...contactAddress.recipient }
                : {
                    lastname: visitor?.lastname || null,
                    firstname: visitor?.firstname || null,
                    patronymic: visitor?.patronymic || null,
                    email: visitor?.email || null,
                    phone: visitor?.mobile || null,
                    phone2: visitor?.phone || null
                  },

              warehouse: warehouse.id
            };

            showAddressList.push({
              value: warehouseAddress,

              locality: warehouseLocality,
              service,
              method,
              company,
              tariff
            });
          }
        }

        deliveryInfo?.address?.forEach((address) => {
          const service = serviceList.find((service) => service.code === address.service);
          const method = methodList.find((method) => method.id === address.method);
          const company = companyList.find((company) => company.service.id === service.id && company.id === address.company);
          const tariff = service && tariffList.find((tariff) => tariff.service.id === service.id && tariff.id === address.tariff);

          if (
            !service ||
            !method ||
            !company ||
            !tariff ||
            !address.address ||
            !address.address.locality
          )
            return;

          if (
            (method.code === 'pickup' && !address.point) ||
            (method.code === 'courier' &&
              (!address.address.street || !address.address.house))
          )
            return;

          if (
            warehouseAddress &&
            address.service === warehouseAddress.service &&
            address.method === warehouseAddress.method &&
            address.company === warehouseAddress.company &&
            address.tariff === warehouseAddress.tariff &&
            address.point?.id === warehouseAddress.point.id
          ) {
            warehouseAddress.recipient = address.recipient;

            return;
          }

          showAddressList.push({
            value: address,

            locality: address.address.locality,
            service,
            method,
            company,
            tariff
          });
        });
      }

      const address = this.state.address;

      if (!address && showAddressList?.length)
        setTimeout(() =>
          this.setState((state) => ({
            ...state,
            address: showAddressList[0].value
          }))
        );

      let checkedIndex = this.findAddress(showAddressList, address);

      if (checkedIndex < 0 && showAddressList?.length)
        setTimeout(
          () =>
            this.setState((state) => ({
              ...state,
              address: showAddressList[0].value
            })),
          1
        );

      return (
        <Query
          cart={cart}
          rightChildren={
            <Button
              disabled={!address}
              variant="contained"
              onClick={(event) => onNextPage(true, address)}
            >
              {langString('delivery.method.use')}
            </Button>
          }
        >
          <Grid container>
            <Grid>
              {!showAddressList ? (
                <Card variant="bordered">
                  <Checkbox disabled variant="radio">
                    <Text strong>
                      <Skeleton />
                    </Text>
                    <Text size="sm">
                      <Skeleton />
                    </Text>
                    <Text size="sm">
                      <Skeleton />
                    </Text>
                  </Checkbox>
                </Card>
              ) : (
                <>
                  {showAddressList.map(
                    (item, index) =>
                      index ===
                        this.findAddress(showAddressList, item.value) && (
                        <Card key={index} variant="bordered">
                          <Checkbox
                            variant="radio"
                            checked={index === checkedIndex}
                            onChange={(event) =>
                              this.setState((state) => ({
                                ...state,
                                address: item.value
                              }))
                            }
                          >
                            <Text strong>
                              <Grid container>
                                <Grid grow={1}>
                                  {item.value.service === 'internal' ? (
                                    <>{item.method.title}:</>
                                  ) : (
                                    <>
                                      {item.company.title} ({item.tariff.title})
                                      &nbsp;-&nbsp;
                                      {item.method.title}:
                                    </>
                                  )}
                                </Grid>
                                {item.company.logo_path ? (
                                  <Grid grow={0}>
                                    <Logo
                                      variant="right"
                                      src={item.company.logo_path}
                                    />
                                  </Grid>
                                ) : null}
                              </Grid>
                            </Text>
                            <Text size="sm">
                              {item.value.point ? (
                                <>
                                  {item.value.point.title}
                                  {item.value.point.address
                                    ? ' (' + item.value.point.address + ')'
                                    : null}
                                </>
                              ) : (
                                <>
                                  {this.renderAddress(item.value.address?.locality, item.value.address?.street)}
                                </>
                              )}
                            </Text>

                            {item.value.point?.description ? (
                              <Text size="sm">
                                {item.value.point.description}
                              </Text>
                            ) : null}
                          </Checkbox>
                        </Card>
                      )
                  )}
                </>
              )}

              <Button
                variant="outlined"
                onClick={(event) => onNextPage(false, address)}
              >
                {langString('delivery.method.another')}
              </Button>
            </Grid>
          </Grid>
        </Query>
      );
    }
  }
);
